import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(auth)/register/components/LoginLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(auth)/register/components/RegisterFormV1.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(auth)/register/components/RegisterFormV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureIsActive"] */ "/app/src/app/components/Only/FeatureIsActive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DefaultHeadScripts"] */ "/app/src/app/lib/root/scripts.tsx");
